(function () {
  const section_instances = new Map();

  function destroy_section(section_id) {
    const entry = section_instances.get(section_id);
    if (!entry) return;
    if (entry.swiper) {
      entry.swiper.destroy(true, true);
    }
    section_instances.delete(section_id);
  }

  function create_section(section_el) {
    if (typeof window.Swiper !== "function") return;

    const section_id = section_el.dataset.sectionId;
    if (!section_id) return;

    destroy_section(section_id);

    const swiper_el = section_el.querySelector("[data-jqh1-rc-swiper]");
    if (!swiper_el) return;

    const slide_count = swiper_el.querySelectorAll(".jqh1-rc__slide").length;
    if (slide_count === 0) return;

    const enable_loop = section_el.dataset.loop === "true" && slide_count > 3;
    const space_between = Number(section_el.dataset.space || 18);
    const space_between_m = Number(section_el.dataset.spaceM || 14);
    const reduce_motion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const swiper = new window.Swiper(swiper_el, {
      slidesPerView: 1.2,
      spaceBetween: space_between_m,
      speed: reduce_motion ? 0 : 500,
      grabCursor: true,
      watchOverflow: true,
      loop: enable_loop,
      a11y: {
        enabled: true,
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide"
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: space_between
        }
      }
    });

    section_instances.set(section_id, {
      swiper: swiper,
      section_el: section_el
    });
  }

  function init_all_sections() {
    document.querySelectorAll("[data-jqh1-rc]").forEach(function (section_el) {
      create_section(section_el);
    });
  }

  function wait_for_swiper(retry) {
    retry = retry || 0;
    if (typeof window.Swiper === "function") {
      init_all_sections();
      return;
    }
    if (retry > 20) return;
    setTimeout(function () {
      wait_for_swiper(retry + 1);
    }, 120);
  }

  document.addEventListener("DOMContentLoaded", function () {
    wait_for_swiper();
  });

  document.addEventListener("shopify:section:load", function (event) {
    const section_el =
      event.target && event.target.closest ? event.target.closest("[data-jqh1-rc]") : null;
    if (!section_el) return;
    create_section(section_el);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    const section_el =
      event.target && event.target.closest ? event.target.closest("[data-jqh1-rc]") : null;
    if (!section_el) return;
    destroy_section(section_el.dataset.sectionId);
  });

  document.addEventListener("shopify:block:select", function (event) {
    const slide_el =
      event.target && event.target.closest ? event.target.closest(".jqh1-rc__slide") : null;
    if (!slide_el) return;
    const section_el = slide_el.closest("[data-jqh1-rc]");
    if (!section_el) return;
    const entry = section_instances.get(section_el.dataset.sectionId);
    if (!entry || !entry.swiper) return;
    const index = Array.prototype.indexOf.call(slide_el.parentNode.children, slide_el);
    entry.swiper.slideTo(index);
  });
})();
